module.exports = __webpack_public_path__ + "static/media/Lion.95779caa.png";